import { Container, Label, FormGroup } from "reactstrap";
// import { Formik, Field, Form  } from "formik";
// import * as Yup from "yup";
// import TextErrors from '../../share/TextErrors'
import "../../share/form.css";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'
// import { bahttext } from "bahttext"


export function AdminCheckOperationReportComponent() {
    const [searchParams] = useSearchParams();
    const supportId = searchParams.get("req");
    const status = searchParams.get("status");
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("userData"))
    // console.log(supportId)
    const [data, setData] = useState([]);
    const [result, setResult] = useState([]);
    // console.log("result", result);

    // console.log("result =>", result)
    // console.log("data", data)
    // const [checkData, setCheckData] = useState([]);
    // console.log("data",data)

    const confirmOperationForm = async () => {
        let postData = new FormData();
        postData.append("supportId", supportId)
        postData.append("roldId", user.roldId)
        postData.append("userApprove", user.fullName)
        try {
            let res = await fetch("api/SupportForm/approveOperationForm", {
                method: "POST",
                body: postData,
            })
            let resJson = await res.json();
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    navigate("/supporting/")
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        } catch (e) {
            // console.log("err", e)
        }
    }
    useEffect(() => {
        const getData = async () => {
            try {
                let res = await fetch(`api/Support/getSupportOperationData/${supportId}`)
                const resJson = await res.json()
                setData(resJson.dataenum);
            } catch (err) {
                // console.log("err",err)
            }
        }
        getData();
    }, [supportId])

    useEffect(() => {
        const checkDataDsdAndPromotion = async () => {
            if (user.roldId === "3" || user.roldId === "4") {
                try {
                    let res = await fetch(`api/SupportForm/getSupportReport/${supportId}`)
                    const resJson = await res.json()
                    setResult(resJson.dataenum);
                } catch (err) {
                    // console.log("err",err)
                }
            }
        }
        checkDataDsdAndPromotion();
    }, [])
    return (
        <Container className="d-flex justify-content-center align-items-center mt-2 mb-4 tab-container">
            <div className="form-border">
                {data?.map((item, i) => (
                    <div className="mt-3 px-5 pt-5">
                        <Label>ชื่อผู้ได้รับเงินช่วยเหลือหรืออุดหนุน</Label>
                        <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.supportName}</p>
                        <div className="mt-3 d-flex justify-content-betwenn align-items-center w-100">
                            <div className="w-50 p-1">
                                <Label className="form-Label">เลขที่คำขอ</Label>
                                {item.supportNo !== null ? (
                                    <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.supportNo}</p>
                                ) : (
                                    <p className="w-100 rounded-pill border text-primary p-1 text-center">-</p>
                                )}
                            </div>
                            <div className="w-50 p-1">
                                <Label className="form-Label">ลงวันที่</Label>
                                <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.approveDate}</p>
                            </div>
                        </div>

                        <Label className="form-Label">ได้รับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (หน่วยงานที่อนุมัติคำขอ)</Label>
                        <p className="w-100 rounded-pill border text-primary p-1 text-center">{item.deptName}</p>

                        <Label className="form-Label">เป็นจำนวนเงิน</Label>
                        <p className="w-100 rounded-pill border text-primary p-1 text-center">{NumberWithCommas(item.amount)} บาท</p>
                    </div>
                ))}

                {result?.map((data) => (
                    <div className="px-5">
                        {data.supportTypeId === "1" || data.supportTypeId === "2" || data.supportTypeId === "3" ? (
                            <>
                                {/* checkbox 2 */}
                                <FormGroup className="">

                                    <p className="input-color">นำเงินช่วยเหลือหรืออุดหนุนที่ได้รับจากกองทุนพัฒนาฝีมือแรงงานไปส่งเสริมการพัฒนาฝีมือแรงงาน ดังนี้</p>
                                    {data?.costCheckbox.map((benefit, i) => (
                                        <div key={i} className="form-check mt-3">
                                            <Label className="form-check-Label" >
                                                {benefit.startsWith("อื่น") ? `${benefit} ${data.supportRemark == null ? "ไม่มี" : data.supportRemark}` : benefit}
                                            </Label>
                                        </div>
                                    ))}
                                    {/* {data?.supportRemark == null ? "-" : data?.supportRemark} */}

                                </FormGroup>

                                {/* checkbox 3 */}
                                <FormGroup className="mt-4">
                                    <p className="input-color">ประโยชน์ที่ได้รับจากการดำเนินการพัฒนาฝีมือแรงงาน</p>
                                    {data?.benefitCheckbox.map((benefit, i) => (
                                        <div key={i} className="form-check mt-3">
                                            <Label className="form-check-Label" >
                                                {benefit.startsWith("อื่น") ? `${benefit} ${data.benefit == null ? "ไม่มี" : data.benefit}` : benefit}
                                            </Label>
                                        </div>
                                    ))}
                                    {/* {data?.benefit == null ? "-" : data?.benefit} */}


                                </FormGroup>

                                {/* issue */}
                                <FormGroup className="mt-3">
                                    <Label>ปัญหาอุปสรรค</Label>
                                    <div className="input-color border border-1 w-100 rounded-pill p-1 text-center ">{data?.costRemark ?? "-"}</div>


                                </FormGroup>

                                {/* remark  */}
                                <FormGroup className="mt-3">
                                    <Label>ข้อคิดเห็นและเสนอแนะ</Label>
                                    <div className="input-color border border-1 w-100 rounded-pill p-1 text-center ">{data?.benefitRemark ?? "-"}</div>
                                </FormGroup>

                            </>
                        ) : null}

                        {data.supportTypeId === "4" || data.supportTypeId === "5" || data.supportTypeId === "6" || data.supportTypeId === "7" || data.supportTypeId === "8" ? (
                            <>
                                {/* checkbox 2 */}
                                <FormGroup className="">

                                    <p className="input-color">นำเงินช่วยเหลือหรืออุดหนุนที่ได้รับจากกองทุนพัฒนาฝีมือแรงงานไปส่งเสริมการพัฒนาฝีมือแรงงาน ดังนี้</p>
                                    {data?.costCheckbox.map((benefit, i) => (
                                        <div key={i} className="form-check mt-3">
                                            <Label className="form-check-Label" >
                                                {benefit.startsWith("อื่น") ? `${benefit} ${data.supportRemark == null ? "ไม่มี" : data.supportRemark}` : benefit}

                                            </Label>
                                        </div>

                                    ))}
                                    {/* {data?.supportRemark == null ? "-" : data?.supportRemark} */}

                                </FormGroup>

                                {/* checkbox 3 */}
                                <FormGroup className="mt-4">
                                    <p className="input-color">ประโยชน์ที่ได้รับจากการดำเนินการพัฒนาฝีมือแรงงานให้แก่ลูกจ้าง</p>
                                    {data?.benefitCheckbox.map((benefit, i) => (
                                        <div key={i} className="form-check mt-3">
                                            <Label className="form-check-Label" >
                                                {benefit.startsWith("อื่น") ? `${benefit} ${data.benefit == null ? "ไม่มี" : data.benefit}` : benefit}

                                            </Label>
                                        </div>
                                    ))}
                                    {/* {data?.benefit == null ? "-" : data?.benefit} */}

                                </FormGroup>

                                {/* issue */}
                                <FormGroup className="mt-3">
                                    <Label>ปัญหาอุปสรรค</Label>
                                    <div className="input-color border border-1 w-100 rounded-pill p-1 text-center ">{data?.costRemark ?? "-"}</div>


                                </FormGroup>

                                {/* remark  */}
                                <FormGroup className="mt-3">
                                    <Label>ข้อคิดเห็นและเสนอแนะ</Label>
                                    <div className="input-color border border-1 w-100 rounded-pill p-1 text-center ">{data?.benefitRemark ?? "-"}</div>
                                </FormGroup>


                            </>
                        ) : null}

                        {data.supportTypeId === "9" ? (
                            <>
                                {/* checkbox 2 */}
                                <FormGroup className="">

                                    <p className="input-color">นำเงินช่วยเหลือหรืออุดหนุนที่ได้รับจากกองทุนพัฒนาฝีมือแรงงานไปส่งเสริมการพัฒนาฝีมือแรงงาน ดังนี้</p>
                                    {data?.costCheckbox.map((benefit, i) => (
                                        <div key={i} className="form-check mt-3">
                                            <Label className="form-check-Label" >
                                                {benefit.startsWith("อื่น") ? `${benefit} ${data.supportRemark == null ? "-" : data.supportRemark}` : benefit}

                                            </Label>
                                        </div>
                                    ))}
                                    {/* {data?.supportRemark == null ? "-" : data?.supportRemark} */}
                                </FormGroup>

                                {/* checkbox 3 */}
                                <FormGroup className="mt-4">
                                    <p className="input-color">ประโยชน์ที่ได้รับจากการดำเนินการพัฒนาฝีมือแรงงานให้แก่ลูกจ้าง</p>
                                    {data?.benefitCheckbox.map((benefit, i) => (
                                        <div key={i} className="form-check mt-3">
                                            <Label className="form-check-Label" >
                                                {benefit.startsWith("อื่น") ? `${benefit} ${data.benefit == null ? "-" : data.benefit}` : benefit}

                                            </Label>
                                        </div>
                                    ))}

                                    {/* {data?.benefit == null ? "-" : data?.benefit} */}


                                </FormGroup>

                                {/* issue */}
                                <FormGroup className="mt-3">
                                    <Label>ปัญหาอุปสรรค</Label>
                                    <div className="input-color border border-1 w-100 rounded-pill p-1 text-center ">{data?.costRemark ?? "-"}</div>


                                </FormGroup>

                                {/* remark  */}
                                <FormGroup className="mt-3">
                                    <Label>ข้อคิดเห็นและเสนอแนะ</Label>
                                    <div className="input-color border border-1 w-100 rounded-pill p-1 text-center ">{data?.benefitRemark ?? "-"}</div>
                                </FormGroup>


                            </>
                        ) : null}
                    </div>


                ))}
                {user.roldId == "4" && status != "2" ? null :
                    <>
                        <div className="d-flex justify-content-center mb-4">
                            <button
                                type="button"
                                onClick={confirmOperationForm}
                                className="btn-blue w-25">
                                รับทราบ
                            </button>
                        </div></>}


            </div>

        </Container>
    )
}